// SPDX-License-Identifier: Apache-2.0

import ChannelState from "../api/types/channelState";
import ProposalID from "../api/types/poposalID";
import Address from "../api/types/address";

/**
 * The representation of a proposal for the client.
 */
export default class Proposal {
  public readonly id: ProposalID;
  public readonly peerAddressEth: Address;
  public readonly peerAddressCC: string;
  public readonly state: ChannelState;

  constructor(
    id: ProposalID,
    peerAddressEth: Address,
    peerAddressCC: string,
    state: ChannelState,
  ) {
    this.id = id;
    this.peerAddressEth = peerAddressEth;
    this.peerAddressCC = peerAddressCC;
    this.state = state;
  }
}
